import * as React from 'react';

import { Button } from '@coursera/cds-core';

import SvgSlack from 'bundles/third-party-auth/components/SvgSlack';

type Props = {
  slackLink?: string;
  buttonText?: string;
  className?: string;
  'aria-label': string;
  onClick?: (event: React.SyntheticEvent<HTMLElement>) => void;
  trackingName?: string;
  buttonVariant?: 'secondary' | 'primary' | 'primaryInvert' | 'ghost' | 'ghostInvert';
};

const SlackButtonV2WithCDS = ({
  slackLink = '',
  buttonText = 'Slack',
  'aria-label': ariaLabel,
  onClick,
  buttonVariant = 'secondary',
}: Props) => {
  return (
    <Button
      size="small"
      component="a"
      href={slackLink}
      target="_blank"
      aria-label={ariaLabel}
      variant={buttonVariant}
      icon={<SvgSlack size={20} />}
      iconPosition="before"
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );
};

export default SlackButtonV2WithCDS;
